import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "TemperatureCool.svg",
  "use": "TemperatureCool.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"TemperatureCool.svg\"><path d=\"M32,60a11.987,11.987,0,0,1-8-20.9251V14A8,8,0,0,1,40,14V39.0749A11.987,11.987,0,0,1,32,60ZM40.0006,48a7.9761,7.9761,0,0,0-3.2117-6.4A1.9746,1.9746,0,0,1,36,40.0174V14a4,4,0,0,0-8,0V40.0174A1.9748,1.9748,0,0,1,27.2109,41.6a7.9976,7.9976,0,1,0,12.79,6.4ZM34,36v4.184a3.82,3.82,0,0,0,1.6076,3.0286,6,6,0,1,1-7.2154,0A3.82,3.82,0,0,0,30,40.1841V36a2,2,0,0,1,4,0Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol